import Styles from './BrandStylePreview.module.scss'
import { Brand } from 'blaze-ui/icons'
import { BrandVisualKit } from 'types'
import cx from 'classnames'
import { BrandCardSize } from '../../BrandAICard/Types'

interface Props {
  kit: BrandVisualKit
  size?: BrandCardSize
  backgroundColor?: string
}

export const BrandStylePreview = ({ kit, size = 'sm', backgroundColor }: Props) => {
  const { primary_logo, name, primary_color_palette } = kit
  const logo = primary_logo?.media_file.source_url

  return (
    <div className={cx(Styles.preview, Styles[size])} style={{ backgroundColor }}>
      {logo ? <img className={Styles.image} src={logo} alt={name} /> : <Brand />}
      {primary_color_palette && (
        <div className={Styles.brandKitPalette}>
          {primary_color_palette.colors.map((color, i) => (
            <div
              key={`${color.hex}-${i}`}
              className={Styles.brandKitPaletteColor}
              style={{ backgroundColor: color.hex }}
            />
          ))}
        </div>
      )}
    </div>
  )
}
